import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(funcionAplausos),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(funcionAbrirZona),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(funcionAbrirEjercicio),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(funcionAbrirVisorFC),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(funcionAbrirEjercicioGG),
    _marked6 =
/*#__PURE__*/
_regeneratorRuntime.mark(funcionAbrirIframe),
    _marked7 =
/*#__PURE__*/
_regeneratorRuntime.mark(ejecutarFuncion),
    _marked8 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchEjecutarFuncion);

import { takeEvery, put, select, call } from 'redux-saga/effects';
import { PANTALLA_VENTANA_ID } from '../index';
import { EJECUTAR_FUNCION, zona, pantalla } from '../actions';
import { selectors } from '..';
import { decodificarZonaId } from '../util';
import funcionImprimirEjercicio from './funciones/imprimir-ejercicio';

function funcionAplausos() {
  var configGeneral, src, audio;
  return _regeneratorRuntime.wrap(function funcionAplausos$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(selectors.getConfigGeneral);

        case 2:
          configGeneral = _context.sent;
          src = configGeneral.audioAplausos || 'contenido/bien.mp3';
          audio = new Audio();
          audio.src = src;
          audio.load();
          audio.play();

        case 8:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function funcionImprimirImg(params) {
  var carpeta = params.split('.')[0];
  var imagenes = params.split('.')[1].split('_');
  var url = encodeURI('printImg.html?carpeta=' + carpeta + '&imgs=' + imagenes.join(','));
  window.open(url, '_blank');
}

function funcionGuardarPDF(params) {
  var fichero = 'contenido/' + params.split('.')[0] + '.pdf';

  if (window.electronContext || window.parent.electronContext) {
    window.open(fichero);
  } else {
    window.open(fichero, '_blank');
  }
}

function funcionMostrarPDF(params) {
  var fichero = 'contenido/' + params.split('.')[0] + '.pdf';

  if (window.electronContext && window.mostrarPDF) {
    window.mostrarPDF(fichero);
  } else if (window.parent.electronContext && window.parent.mostrarPDF) {
    window.parent.mostrarPDF(fichero);
  } else {
    window.open(fichero, '_blank');
  }
} // zonaId es de la forma LLPPP.Z donde
// LL es libroId
// PPP es numPagina
// Z es numZona


function funcionAbrirZona(zonaId) {
  var _decodificarZonaId, libroId, numPagina, numZona;

  return _regeneratorRuntime.wrap(function funcionAbrirZona$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _decodificarZonaId = decodificarZonaId(zonaId), libroId = _decodificarZonaId.libroId, numPagina = _decodificarZonaId.numPagina, numZona = _decodificarZonaId.numZona;
          _context2.next = 3;
          return put(zona(libroId, numPagina, numZona));

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function funcionAbrirEjercicio(libroId, numPagina, numZona) {
  var props;
  return _regeneratorRuntime.wrap(function funcionAbrirEjercicio$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          props = {
            libroId: libroId,
            numPagina: numPagina,
            numZona: numZona,
            libroIdGuardado: libroId,
            numPaginaGuardado: numPagina,
            numZonaGuardado: numZona
          };
          _context3.next = 3;
          return put(pantalla(PANTALLA_VENTANA_ID, props));

        case 3:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function funcionAbrirVisorFC(libroId, numPagina, numZona, params) {
  var props;
  return _regeneratorRuntime.wrap(function funcionAbrirVisorFC$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          props = {
            libroId: libroId,
            numPagina: numPagina,
            numZona: numZona,
            libroIdGuardado: libroId,
            numPaginaGuardado: numPagina,
            numZonaGuardado: numZona,
            zona: {
              vinculo: 'funcion,abrirVisorFC:' + params
            }
          };
          _context4.next = 3;
          return put(pantalla(PANTALLA_VENTANA_ID, props));

        case 3:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function funcionAbrirEjercicioGG(libroId, numPagina, numZona, params) {
  var props;
  return _regeneratorRuntime.wrap(function funcionAbrirEjercicioGG$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          props = {
            libroId: libroId,
            numPagina: numPagina,
            numZona: numZona,
            libroIdGuardado: libroId,
            numPaginaGuardado: numPagina,
            numZonaGuardado: numZona,
            zona: {
              vinculo: 'funcion,abrirEjercicioGG:' + params
            }
          };
          _context5.next = 3;
          return put(pantalla(PANTALLA_VENTANA_ID, props));

        case 3:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function funcionAbrirIframe(libroId, numPagina, numZona) {
  var props;
  return _regeneratorRuntime.wrap(function funcionAbrirIframe$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          props = {
            libroId: libroId,
            numPagina: numPagina,
            numZona: numZona,
            libroIdGuardado: libroId,
            numPaginaGuardado: numPagina,
            numZonaGuardado: numZona
          };
          _context6.next = 3;
          return put(pantalla(PANTALLA_VENTANA_ID, props));

        case 3:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function ejecutarFuncion(_ref) {
  var libroId = _ref.libroId,
      numPagina = _ref.numPagina,
      numZona = _ref.numZona,
      nombre = _ref.nombre,
      params = _ref.params;
  return _regeneratorRuntime.wrap(function ejecutarFuncion$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.t0 = nombre;
          _context7.next = _context7.t0 === 'aplausos' ? 3 : _context7.t0 === 'abrirZona' ? 6 : _context7.t0 === 'abrirEjercicio' ? 9 : _context7.t0 === 'abrirEjercicioGG' ? 12 : _context7.t0 === 'abrirVisorFC' ? 15 : _context7.t0 === 'abrirIframe' ? 18 : _context7.t0 === 'imprimirImg' ? 21 : _context7.t0 === 'guardarPDF' ? 23 : _context7.t0 === 'mostrarPDF' ? 25 : _context7.t0 === 'imprimirEjercicio' ? 27 : 29;
          break;

        case 3:
          _context7.next = 5;
          return call(funcionAplausos);

        case 5:
          return _context7.abrupt('break', 34);

        case 6:
          _context7.next = 8;
          return call(funcionAbrirZona, params);

        case 8:
          return _context7.abrupt('break', 34);

        case 9:
          _context7.next = 11;
          return call(funcionAbrirEjercicio, libroId, numPagina, numZona);

        case 11:
          return _context7.abrupt('break', 34);

        case 12:
          _context7.next = 14;
          return call(funcionAbrirEjercicioGG, libroId, numPagina, numZona, params);

        case 14:
          return _context7.abrupt('break', 34);

        case 15:
          _context7.next = 17;
          return call(funcionAbrirVisorFC, libroId, numPagina, numZona, params);

        case 17:
          return _context7.abrupt('break', 34);

        case 18:
          _context7.next = 20;
          return call(funcionAbrirIframe, libroId, numPagina, numZona);

        case 20:
          return _context7.abrupt('break', 34);

        case 21:
          funcionImprimirImg(params);
          return _context7.abrupt('break', 34);

        case 23:
          funcionGuardarPDF(params);
          return _context7.abrupt('break', 34);

        case 25:
          funcionMostrarPDF(params);
          return _context7.abrupt('break', 34);

        case 27:
          funcionImprimirEjercicio();
          return _context7.abrupt('break', 34);

        case 29:
          if (!(typeof window[nombre] === 'function')) {
            _context7.next = 32;
            break;
          }

          window[nombre](params);
          return _context7.abrupt('return');

        case 32:
          // y si no existe, informamos por consola
          window.console.error('sagas/watch-ejecutar-funcion desconocido (nombre: ' + nombre + ', params: ' + params + ')');
          return _context7.abrupt('break', 34);

        case 34:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function watchEjecutarFuncion() {
  return _regeneratorRuntime.wrap(function watchEjecutarFuncion$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return takeEvery(EJECUTAR_FUNCION, ejecutarFuncion);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

export default watchEjecutarFuncion;